export const dramaMeta = {
  title: "欲望的诱惑",
  tagline: "大结局与全剧剧情解析中心",
  intro:
    "围绕《欲望的诱惑》的剧情介绍、大结局讲了什么、结局是什么、分集剧情脉络与最新剧情展开整理。本站把零散的观看疑问集中到一页，帮你快速定位想了解的部分，再顺着线索往下读。",
  genre: "都市情感 · 人性悬疑",
  note: "本站内容为剧情脉络与观后讨论方向的整理与解读，用于辅助理解主线走向；具体台词、镜头与人物结局细节，请以正式播出的内容为准。",
  chips: [
    { icon: "ri-flag-2-line", label: "大结局解析" },
    { icon: "ri-book-open-line", label: "全剧剧情介绍" },
    { icon: "ri-list-check-2", label: "分集脉络梳理" },
    { icon: "ri-time-line", label: "最新剧情追踪" },
  ],
};

export const heroStats = [
  { value: "36", unit: "集", label: "主线剧情脉络梳理" },
  { value: "4", unit: "条", label: "结局解读方向" },
  { value: "8", unit: "段", label: "剧情阶段划分" },
  { value: "6", unit: "个", label: "关键人物线索" },
];

export const plotParagraphs = [
  "《欲望的诱惑》把镜头对准都市里一群看起来已经拥有很多的人。他们事业体面、关系稳定、被旁人羡慕，却在光鲜的表层之下各有各的空缺：有人渴望被看见，有人渴望被承认，有人只是害怕失去既有的一切。故事从一次看似寻常的重逢开始，把旧人旧事重新拉回到台前，也让原本被小心维持的平衡出现第一道裂缝。",
  "推动剧情前进的不是单一的反派，而是「欲望」本身。每一次选择都像一次下注：想要更多，就得先交出点什么。剧中人物不断在诚实与体面、爱情与利益、自我与关系之间摇摆，一个谎言通常需要下一个谎言来兜底。正因为每个人都觉得自己有不得已的理由，冲突才显得难以简单评判对错。",
  "随着信息被逐步揭开，早期看似随口的一句台词、一个眼神、一件被搁置的旧物，都会在后段变成关键线索。剧情在中段加速，把所有人物推到必须摊牌的位置；到了后段，故事讨论的重心也从「谁赢了」转向「代价是什么」。这也是整部剧最值得回味的地方——它讲的是诱惑如何发生，以及诱惑过后人还要如何面对自己。",
];

export const endingKeyPoints = [
  {
    icon: "ri-links-line",
    title: "主线关系如何收束",
    desc: "大结局首先交代的是核心关系对的最终位置：经历了试探、越界与坦白之后，他们不再回避当初真正的问题，而是要给这段关系一个明确的答案。收尾通常不会停留在情绪高点，而是落到一个具体、可继续生活下去的日常场景里。",
  },
  {
    icon: "ri-scales-3-line",
    title: "选择带来的代价",
    desc: "结局并不奖励所有手段。为了得到想要的东西而不计后果的人，会在最后面对自己种下的结果：失去信任、失去位置，或失去原本最在意的人。代价不是外部的惩罚，而是选择本身的回响。",
  },
  {
    icon: "ri-user-heart-line",
    title: "主角的转变",
    desc: "真正被写在结局里的成长，是主角对「欲望」态度的改变——从被推着走，到主动承认自己想要什么、并愿意为它负责。这个转变往往通过一个小动作或一句平静的话呈现，而不是靠大段独白。",
  },
  {
    icon: "ri-question-answer-line",
    title: "留给观众的余韵",
    desc: "结局不会把每一件事都焊死。部分支线以留白处理，让人物带着未完成的状态继续生活。这种开放感不是没讲完，而是把解释权交还给观众：重要的不是唯一答案，而是你更认同哪一种活法。",
  },
];

export const endingTabs = [
  {
    id: "main",
    label: "主角归宿",
    heading: "大结局讲了什么：主角最终走向哪里",
    paragraphs: [
      "就主线而言，大结局要做的是给两位核心人物的拉扯一个落点。前面积累的误会、隐瞒与被压抑的真实心意，在最后必须被一次性摊开。结局的处理方式，是让别人物的评判暂时退场，只留下两个人如何面对彼此留下的痕迹。",
      "值得注意的是，收尾没有回避他们在这段关系里造成过的伤害。想继续走下去，就必须先承认「我们都做错了」，再决定要不要一起承担。这也是大结局最容易被讨论的部分：它给出的不是一个完美的团圆，而是一个更接近现实的选择。",
    ],
    points: ["摊开旧账，直面矛盾", "成长代替原谅的戏剧化处理", "落点回到日常而非情绪高点"],
  },
  {
    id: "villain",
    label: "阻碍者下场",
    heading: "结局是什么：站在对立面的人得到了什么",
    paragraphs: [
      "推动冲突的对手角色，并不是单纯的坏人。他们大多有清晰的动机与合理的恐惧，只是在某个岔路口选择了一条更省事的路。大结局对他们的安排，重点不在「报应」，而在于让他们亲眼看到自己选择的结果。",
      "有的角色在最后选择收手，把主动权交还出去；有的角色则坚持到底，最终失去了最初想要守住的东西。两种处理都指向同一个命题：当一个人把欲望当成唯一标尺时，他反而更容易失去自己。",
    ],
    points: ["动机合理，选择有代价", "收手与执念形成对照", "结果指向选择而非惩罚"],
  },
  {
    id: "foreshadow",
    label: "隐藏伏笔",
    heading: "那些早早埋下的线索，结局如何回收",
    paragraphs: [
      "这部剧很擅长把关键信息藏在不起眼的位置。前段里一件被反复出现的旧物、一句带着停顿的对话、一个被刻意留在画面边缘的人，往往都在为后段做铺垫。二刷时最容易发现的，正是这些看似随意却前后呼应的细节。",
      "到了结局，这些线索会集中回收：原本被忽略的动机得到解释，早期人物的异常反应也有了合理来源。理解这些呼应之后，再回头看前面几集，会发现人物的每一次回避都不是偶然。",
    ],
    points: ["旧物与台词的前后呼应", "边缘人物的意外作用", "前期异常行为的合理来源"],
  },
  {
    id: "open",
    label: "开放式解读",
    heading: "关于结局，观众为什么会吵起来",
    paragraphs: [
      "结局播出后，讨论最集中的地方在于它是否给出了明确答案。喜欢开放式处理的人认为，留白让人物更贴近真实生活；希望有明确交代的人则觉得，某些支线还可以再收束得清楚一些。两种感受都成立，因为它们关注的其实是不同的重点。",
      "与其纠结哪种解读「正确」，不如把它看成一个选择题：你更在意人物的情感走向，还是整条因果链的闭合？带着这个问题重看结局，往往能读出属于自己的那一层。",
    ],
    points: ["留白 vs 明确交代的分歧点", "情感走向与因果闭合的侧重不同", "同一结局的多重理解空间"],
  },
];

export const episodeStages = [
  { id: "all", label: "全部阶段" },
  { id: "start", label: "开端" },
  { id: "develop", label: "发展" },
  { id: "turn", label: "转折" },
  { id: "finale", label: "结局" },
];

export const episodeArcs = [
  {
    id: "arc-1",
    range: "第 1–4 集",
    stage: "start",
    stageLabel: "开端",
    title: "看似完满的相遇",
    summary:
      "故事从一段表面平稳的关系展开，主要人物在都市生活的光鲜之下各怀心思。一次偶然的重逢让旧人重新出现，也把当年没有说清楚的事情重新摆上台面。本阶段以人物登场和关系铺垫为主，节奏舒缓，却处处留下暗示。",
    tags: ["人物登场", "关系铺垫"],
  },
  {
    id: "arc-2",
    range: "第 5–8 集",
    stage: "start",
    stageLabel: "开端",
    title: "平静里的第一道裂缝",
    summary:
      "原本被小心维持的平衡开始松动。一方试图用忙碌和体面掩盖不安，另一方则在旧情与现实之间反复权衡。观众能明显感到每个人都在回避某个共同话题，而这正是后续冲突的起点。",
    tags: ["矛盾萌芽", "心理刻画"],
  },
  {
    id: "arc-3",
    range: "第 9–13 集",
    stage: "develop",
    stageLabel: "发展",
    title: "诱惑以一种温柔的姿态靠近",
    summary:
      "冲突进入明面。人物开始为自己的选择寻找理由，并用「不得已」说服自己越界。本阶段把「欲望」具象化为一个个具体诱惑：一次机会、一句承诺、一个可以让自己轻松一点的决定。",
    tags: ["冲突升级", "选择成本"],
  },
  {
    id: "arc-4",
    range: "第 14–18 集",
    stage: "develop",
    stageLabel: "发展",
    title: "谎言需要更多谎言来兜底",
    summary:
      "越界之后，人物不得不开始处理后果。为了维持现有的局面，一个个新的隐瞒被制造出来，形成连锁反应。此前埋下的细节在此阶段陆续回响，观众开始拼凑出完整的关系全貌。",
    tags: ["线索回收", "多米诺效应"],
  },
  {
    id: "arc-5",
    range: "第 19–23 集",
    stage: "turn",
    stageLabel: "转折",
    title: "信任崩塌的那一刻",
    summary:
      "关键真相被揭开，长期累积的不信任集中爆发。所有人物被迫站到台前表态，原本稳固的关系网出现明显撕裂。本阶段是全剧节奏最紧、情绪密度最高的一段。",
    tags: ["真相揭开", "情绪爆发"],
  },
  {
    id: "arc-6",
    range: "第 24–28 集",
    stage: "turn",
    stageLabel: "转折",
    title: "每个人都必须做出选择",
    summary:
      "摊牌之后，人物不再能靠回避拖延。有人选择坦白，有人选择赌一把，也有人选择退出。不同选择把这群人推向不同的方向，也为结局的分岔埋下基础。",
    tags: ["立场分化", "人物弧光"],
  },
  {
    id: "arc-7",
    range: "第 29–32 集",
    stage: "turn",
    stageLabel: "转折",
    title: "代价开始显现",
    summary:
      "选择的后果逐一兑现。为了得到想要的东西而不计手段的人，开始面对失去；一直沉默的人也终于说出自己真正的想法。本阶段把讨论重心从「谁赢了」转向「值得吗」。",
    tags: ["后果兑现", "主题深化"],
  },
  {
    id: "arc-8",
    range: "第 33–36 集",
    stage: "finale",
    stageLabel: "结局",
    title: "大结局：代价、坦白与余韵",
    summary:
      "结局把主线关系、对立角色的去向与前期伏笔集中收束。故事没有停在情绪的高点，而是给出一个更接近日常的落点，让部分支线带着未完成的状态继续。最终想传达的，不是唯一答案，而是面对欲望时每个人的不同活法。",
    tags: ["主线收束", "留白处理"],
  },
];

export const latestUpdates = [
  {
    tag: "结局解析",
    title: "大结局章节整理完成",
    desc: "把主线关系、对立角色与伏笔回收三条线索放在一起，方便对照理解结局到底交代了哪些事。",
    link: "#ending",
    linkText: "看结局解析",
  },
  {
    tag: "剧情脉络",
    title: "分集脉络按阶段重新梳理",
    desc: "将全剧拆成开端、发展、转折、结局四个阶段，并补上每段的核心冲突关键词，查找更快。",
    link: "#episodes",
    linkText: "看分集脉络",
  },
  {
    tag: "人物线索",
    title: "关键人物动机逐一补全",
    desc: "从六位主要人物出发，说明他们各自想要什么、怕失去什么，以及这些动机如何推动剧情。",
    link: "#characters",
    linkText: "看人物线索",
  },
  {
    tag: "主题解读",
    title: "「欲望」这条主线为什么难评判对错",
    desc: "从选择、代价与自我认同三个角度，解释这部剧为什么很少给人非黑即白的答案。",
    link: "#themes",
    linkText: "看主题解读",
  },
  {
    tag: "观看帮助",
    title: "常见疑问集中解答",
    desc: "把大家最常问的结局疑问、剧情顺序与观看方式整理成问答，读起来更省时间。",
    link: "#faq",
    linkText: "看常见问题",
  },
];

export const characters = [
  {
    icon: "ri-user-star-line",
    name: "沈婧",
    role: "核心人物 · 想要被承认",
    desc: "表面独立体面，内心始终渴望被真正看见。她的每一次靠近与退让都带着计算，却也在关键时刻流露出真心。她的转变是全剧情感线的重心。",
    color: "primary",
  },
  {
    icon: "ri-user-3-line",
    name: "陆承宇",
    role: "核心人物 · 想要守住现状",
    desc: "擅长把局面维持在可控范围内，最怕的是失去已经拥有的一切。他看上去从容，实则一直在回避真正的问题，直到无法再躲。",
    color: "secondary",
  },
  {
    icon: "ri-user-4-line",
    name: "程蔓",
    role: "关系里的清醒者",
    desc: "看得最透却说得最少的人。她既是被牵连者，也是推动真相浮出的关键。许多被忽略的细节，都是通过她的视角被观众发现的。",
    color: "accent",
  },
  {
    icon: "ri-user-5-line",
    name: "高远",
    role: "诱惑的化身",
    desc: "他并不靠隐瞒制造冲突，而是靠「给你一个更轻松的选择」推动人物越界。动机合理，选择却越来越难以回头。",
    color: "primary",
  },
  {
    icon: "ri-user-6-line",
    name: "郑亦宁",
    role: "利益与情感的交叉点",
    desc: "她的立场始终摇摆，因为无论靠向哪一边都要付出代价。她的犹豫让剧情保持了灰度，也制造了多次意料之外的转折。",
    color: "secondary",
  },
  {
    icon: "ri-user-location-line",
    name: "宋柏舟",
    role: "沉默的见证者",
    desc: "戏份不多却频繁出现在关键场景，早期看似背景板，后段却成为串联线索、解释动机的重要一环。",
    color: "accent",
  },
];

export const themes = [
  {
    icon: "ri-fire-line",
    title: "欲望不是恶，回避才是",
    desc: "剧里几乎没有人是纯粹的坏。真正的裂缝往往来自不敢承认自己想要什么，于是用体面和借口把自己越推越远。",
  },
  {
    icon: "ri-scales-3-line",
    title: "每个选择都有标价",
    desc: "得到什么，就要准备失去什么。剧情不断强调选择背后的代价，让「赢」这个字变得不那么轻松。",
  },
  {
    icon: "ri-shield-line",
    title: "体面是一层很薄的外壳",
    desc: "人物越是努力维持形象，越容易在细节处露馅。剧集善于用生活化的场景，戳破精心布置的表象。",
  },
  {
    icon: "ri-compass-3-line",
    title: "成长是学会负责",
    desc: "结局并不奖励手段，而是让主角从被欲望推着走，变成主动承认并承担。这是整部剧想要传达的核心。",
  },
  {
    icon: "ri-eye-line",
    title: "真相总会迟到，但不会缺席",
    desc: "前半段刻意压住的信息，会在后半段集中回响。观众与人物几乎同时意识到，当初的沉默意味着什么。",
  },
  {
    icon: "ri-heart-3-line",
    title: "关系经不起长期的默认",
    desc: "很多矛盾不是爆发出来的，而是被默认出来的。剧集提醒观众，不去处理的问题不会消失，只会积累。",
  },
];

export const faqItems = [
  {
    q: "《欲望的诱惑》大结局讲了什么？",
    a: "大结局主要交代三件事：主线关系对最终走向哪里、站在对立面的人物得到了怎样的结果、以及前期埋下的伏笔如何回收。整体处理偏向把情绪落到日常，而不是停在高潮场面。",
  },
  {
    q: "欲望的诱惑结局是什么，算圆满吗？",
    a: "不能简单用圆满或不圆满来概括。它给主线一个更接近现实的选择：先承认彼此造成的伤害，再决定是否继续。部分支线保留了留白，把解释空间留给观众。",
  },
  {
    q: "没看过前面，能直接看剧情介绍吗？",
    a: "可以。本页的「剧情介绍」用三段概括了背景、核心冲突与主题走向，即使从零开始也能建立整体印象，再往下读分集脉络会更顺。",
  },
  {
    q: "分集剧情是按什么整理的？",
    a: "为了让查找更高效，本页按开端、发展、转折、结局四个阶段，把全剧拆成八段脉络，并标注每段的核心冲突关键词。你可以用上方的筛选按钮只看某个阶段。",
  },
  {
    q: "什么是「最新剧情」？",
    a: "「最新剧情」是把近期补充的解析、人物线索与主题解读集中展示，方便已经看过前面内容的观众，第一时间找到新增的解读方向。",
  },
  {
    q: "页面里的解读一定准确吗？",
    a: "页面内容是对剧情脉络与常见讨论方向的整理，用于辅助理解主线。涉及具体台词、镜头与人物结局的细节，仍建议以正式播出的内容为准。",
  },
];

export const keywordLinks = [
  "欲望的诱惑",
  "欲望的诱惑大结局",
  "欲望的诱惑结局是什么",
  "欲望的诱惑剧情介绍",
  "欲望的诱惑分集剧情",
  "欲望的诱惑最新剧情",
  "欲望的诱惑剧情详解",
];

export const navItems = [
  { id: "overview", label: "剧情介绍" },
  { id: "ending", label: "大结局解析" },
  { id: "episodes", label: "分集剧情" },
  { id: "latest", label: "最新剧情" },
  { id: "characters", label: "人物线索" },
  { id: "themes", label: "主题解读" },
  { id: "faq", label: "常见问题" },
];